import 'core-js/features/array/includes';

const arabicLocales = ['ar-AR', 'ar-SA', 'ur-IN'];
const dateFormatters = {
    'fa-IR': persianDate,
    'ja-JP': japaneseDate,
    'pa-IN': punjabiDate,
    'pt-BR': portugueseDate,
    'ru-RU': russianDate,
};

// The following date formatting overrides are specific to the election day as it appears on the chart
// Do not rely on the following for any other kind of date formatting across this project

function persianDate(date) {
    const month = date.toLocaleDateString('fa-IR', { month: 'short' });
    const day = date.toLocaleDateString('fa-IR', { day: '2-digit' });
    return `${day} ${month}`;
}

function punjabiDate(date) {
    const month = date.toLocaleDateString('pa-IN', { month: 'long' });
    const day = date.toLocaleDateString('pa-IN', { day: '2-digit' });
    return `${day} ${month}`;
}

function portugueseDate(date) {
    // Breaking the date down into day and month removes
    // the optional `de` separator, making the date even shorter
    const month = date.toLocaleDateString('pt-BR', { month: 'short' });
    const day = date.toLocaleDateString('pt-BR', { day: '2-digit' });
    return `${day} ${month}`;
}

function russianDate(date) {
    // Makes Russian date even shorter by removing specific characters. Don't try this at home, kids
    const month = date.toLocaleDateString('ru-RU', { month: 'short' });
    const day = date.toLocaleDateString('ru-RU', { day: '2-digit' });
    return `${day} ${month}`.replace(/0|б|\./g, '');
}

function japaneseDate(date) {
    const dateOptions = {
        month: 'short',
        day: 'numeric',
    };
    return date.toLocaleDateString('ja-JP', dateOptions);
}

const dateLocale = locale => {
    if (arabicLocales.includes(locale)) {
        return `${locale}-u-ca-gregory-nu-latn`;
    }
    return locale;
};

function formatShortDate(d, locale = 'en-GB') {
    if (!d) return '';
    const date = new Date(d);

    if (dateFormatters[locale]) {
        return dateFormatters[locale](date);
    }

    const loc = dateLocale(locale);
    const dateOptions = {
        month: 'short',
        day: '2-digit',
    };

    return date.toLocaleDateString(loc, dateOptions);
}

export default formatShortDate;
